import { Divider, Flex, Box, Text } from '@cad-arc';
import { CloseMapLedgerAndClearSelectedEntityButton } from '../close-map-ledger-and-clear-selected-entity-button';
import { getStationIconByAgencyTypeGlobalAttrId } from '../helpers';
import { FR_ICON_SIZE, ICON_SIZE } from '../constants';
import { CommonSize } from '../../../../common/helpers/utils';

type StationOverviewProps = {
    stationNumber: string;
    agencyTypeGlobalAttrId?: number;
    size?: CommonSize;
};

export function StationOverview({
    stationNumber,
    agencyTypeGlobalAttrId,
    size,
}: StationOverviewProps): React.ReactElement {
    const stationIcon = getStationIconByAgencyTypeGlobalAttrId(agencyTypeGlobalAttrId);

    const iconSize = size === 'lg' ? FR_ICON_SIZE : ICON_SIZE;

    return (
        <Box data-testid="MAP_STATION_OVERVIEW_SECTION">
            <Flex alignItems="center" justifyContent="space-between" padding="12px 18px">
                <Flex alignItems="center" gap={1}>
                    <Flex alignItems="center" width={iconSize} minWidth={iconSize}>
                        <img src={stationIcon} alt="icon" data-testid="MAP_STATION_ICON" />
                    </Flex>
                    <Text fontSize={size} fontWeight="bold" style={{ wordBreak: 'break-word' }}>
                        Station {stationNumber}
                    </Text>
                </Flex>
                <CloseMapLedgerAndClearSelectedEntityButton />
            </Flex>
            <Divider />
        </Box>
    );
}
